/* jade-v2-steam.js · section 2 of the Jade v2 page: SIX HOURS OF STEAM, the step machine.
   Ported from v5 mod-steam.js (3 Oct 2026). Vanilla: one passive scroll listener, one rAF, every position measured on build.
   The stage holds (position: sticky) while the visitor scrolls a runway of six steps; every STEP of scroll moves the state one on:
   0 the empty still (seen while the chapter arrives) · 1 resin in · 2 steam through it · 3 steam up the neck · 4 cooled to liquid ·
   5 the oil drawn off, drop by drop · 6 six hours, start to finish (a gentle push toward the bottle on laptops).
   The state is written once per crossing (data-state + --k on the stage); CSS does the rest. Scroll back and it runs back.
   Reduced motion, Save-Data, no SSD (jade-v2-core.js did not boot), no JS, a screen too short, or any error: the markup's own state
   (the finished drawing, the clock at six, the five steps listed, the closing line).
   Runs after jade-v2-core.js (both deferred, in document order). */
(function () {
  var d = document, w = window;

  function init() {
    var root = d.getElementById('d-steam');
    if (!root || root.__dSteam) return;
    root.__dSteam = 1;
    var SSD = w.SSD;
    if (!SSD || !SSD.onReady) return;   /* no core: the static, fully drawn diagram */
    if (typeof SSD.reveal === 'function') { try { SSD.reveal(root); } catch (e) {} }
    var reduced = SSD.reduced || /[?&]jv2reduce=1/.test(location.search) || w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    warm(root);
    try { live(root, SSD); } catch (err) { if (w.console) console.error('[jade-v2-steam]', err); undo(root); }
  }

  /* base and patches: fetched in reading order by the page's picture queue (jade-v2-core.js, SSD.pics) with everything else, and
     decoded before they show. One still on its way when the chapter shows waits at opacity 0 (data-w) and fades in decoded,
     instead of popping in. */
  function warm(root) {
    var c = navigator.connection, imgs = root.querySelectorAll('.d-steam-push img');
    if (c && c.saveData) return;
    [].forEach.call(imgs, function (i) {
      if (i.complete) return;
      i.setAttribute('data-w', '');
      i.addEventListener('load', function () { (i.decode ? i.decode() : Promise.resolve()).catch(Object).then(function () { i.removeAttribute('data-w'); }); });
    });
  }

  function undo(root) {
    root.classList.remove('d-steam--live', 'd-steam--init');
    var st = root.querySelector('.d-steam-stage');
    if (st) { st.setAttribute('data-state', '6'); st.style.removeProperty('--k'); }
  }

  function live(root, SSD) {
    var run = root.querySelector('.d-steam-run'), stage = root.querySelector('.d-steam-stage'), head = root.querySelector('.d-steam-head');
    var bar = d.getElementById('d-bar') || d.getElementById('stickybuy');
    var wide = w.matchMedia('(min-width: 900px)');
    var k = -1, seen = 0, lastW = 0, top = 0, STEP = 300, ticking = false, off = false;

    root.classList.add('d-steam--live', 'd-steam--init');

    /* phones: the heading scrolls away and the drawing + clock hold, centred in the space above the bottom bar (the
       stage's top goes negative by the heading's height). Laptops: the whole stage holds under the top bar.
       Measured on width change only (never on the iOS toolbar's height change). */
    function place() {
      var vw = w.innerWidth; if (vw === lastW) return; lastW = vw;
      /* the page's held screen (jade-v2-story.liquid's --sv on touch screens), so a browser's bars never resize the runway */
      var vh = (parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--sv')) * 100) || d.documentElement.clientHeight, barH = bar ? bar.offsetHeight : 0;
      /* a screen too short to hold the drawing and the clock together (a phone turned sideways): the static, finished
         drawing with all five steps listed, until the screen is tall enough again */
      off = vh < 540;
      root.classList.toggle('d-steam--live', !off);
      if (off) { k = -1; stage.setAttribute('data-state', '6'); stage.style.removeProperty('--k'); return; }
      root.style.setProperty('--d-steam-bar', barH + 'px');
      if (!wide.matches) {
        root.style.removeProperty('--d-steam-hgap');
        var mb0 = parseFloat(getComputedStyle(head).marginBottom) || 0;
        var rest = stage.offsetHeight - head.offsetHeight - mb0;
        var gap = Math.max(8, Math.round((vh - barH - rest) / 2));
        var mb = Math.max(mb0, gap + 8);               /* no sliver of the heading shows above the pinned drawing */
        root.style.setProperty('--d-steam-hgap', mb + 'px');
        top = -(head.offsetHeight + mb) + gap;
        STEP = Math.round(vh * 0.26);   /* v5 v2 (3 Oct): the shortened phone step, was 0.34 */
      } else {
        top = barH;
        STEP = Math.round(vh * 0.38);
      }
      root.style.setProperty('--d-steam-top', top + 'px');
      root.style.setProperty('--d-steam-runway', (6 * STEP) + 'px');
    }

    function set(n) {
      if (n === k) return; k = n;
      stage.setAttribute('data-state', String(n));
      stage.style.setProperty('--k', String(n));
      if (n > seen) { seen = n; if (SSD.track) SSD.track('steam_step', { step: n }); }
    }

    /* dd = how far the stage has travelled since it pinned; state n begins at dd = (n - 0.8) * STEP, so 0 is what the
       visitor sees while the chapter arrives and 6 holds for the last 0.8 STEP before the stage lets go */
    function frame() {
      ticking = false;
      if (off) return;
      var dd = top - run.getBoundingClientRect().top;
      set(Math.max(0, Math.min(6, Math.floor((dd + 0.8 * STEP) / STEP))));
    }
    /* the read waits for the task right after the frame (4 Oct): getBoundingClientRect in a rAF forced the scroll-driven page's
       style recalc early, 64-73 ms per 10 s at 4x CPU; after the frame, layout is clean and the read is free. A state is a CSS
       transition, so it starting one frame (16 ms) later is not visible. */
    function kick() { if (!ticking) { ticking = true; w.setTimeout(frame, 0); } }

    place();
    frame();
    /* two frames later the first state has painted without transitions; from now on every change animates */
    w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { root.classList.remove('d-steam--init'); }); });
    /* only while the chapter is within a screen of view; one last frame on leaving settles the state */
    var inView = !('IntersectionObserver' in w);
    if (!inView) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; kick(); }, { rootMargin: '100% 0px 100% 0px' }).observe(root);
    w.addEventListener('scroll', function () { if (inView) kick(); }, { passive: true });
    w.addEventListener('resize', function () {
      /* width changes re-measure; a height change only matters when it crosses the too-short line */
      var short = d.documentElement.clientHeight < 540; if (short !== off) lastW = 0;
      place(); kick();
    }, { passive: true });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { lastW = 0; place(); kick(); });
    /* the deferred stylesheet and the late layout of the main column: measure again once the page has loaded, and when the column's width moves */
    function again() { lastW = 0; place(); kick(); }
    w.addEventListener('load', again);
    if (w.ResizeObserver) {
      var cw = root.offsetWidth;
      new w.ResizeObserver(function () { var nw = root.offsetWidth; if (nw !== cw) { cw = nw; again(); } }).observe(root);
    }
    root.__dSteamLive = true;
  }

  if (w.SSD && w.SSD.onReady) w.SSD.onReady(init);
})();
